import { render, staticRenderFns } from "./ProjectGridCard.vue?vue&type=template&id=0c8037e7"
import script from "./ProjectGridCard.vue?vue&type=script&lang=ts"
export * from "./ProjectGridCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports